module.exports = kolibriGlobal.utils.browser;